<template>
  <div :id="params.type" class="page">
    <template v-if="!loading">
      <Banner :banner="page.banner" />
      <section id="content_section" class="container bg-white text-left">
        <div class="row" style="position: relative">
          <div class="pt-4 pb-5" :class="page.sidemenu? 'col-lg-9 order-lg-2': 'col-lg-12'">
            <div v-if="page.sidemenu" class="float-right fixed_toggle">
              <button
                type="button"
                class="btn btn-link btn-sm toggle_menu_btn bg-primary text-white"
                @click="toggleSideMenu()"
              >
                <template v-if="page.sidemenu.collapsed">
                  <i class="fa fa-chevron-left" />
                  {{ $t("component.toggle_btn.show_sidemenu") }}
                </template>
                <template v-else>
                  <i class="fa fa-chevron-right" />
                  {{ $t("component.toggle_btn.hide_sidemenu") }}
                </template>
              </button>
            </div>
            <template v-if="params.type === 'beneficiaries'">
              <b-link
                v-if="!params.osc_year || params.osc_year === current_osc_year"
                class="float-right btn btn-sm btn-link"
                :to="`/beneficiaries/${current_osc_year - 1 }`"
              >
                <i class="fa fa-chevron-left"></i>
                {{ $t("message.view_year", {osc_year: current_osc_year - 1}) }}
              </b-link>
              <b-link v-else class="float-right btn btn-sm btn-link" to="/beneficiaries">
                <i class="fa fa-chevron-right"></i>
                {{ $t("message.view_year", {osc_year: current_osc_year}) }}
              </b-link>
            </template>
            <Breadcrumb :items="[{ name: page.title, url: `/${params.type}` }]" />
            <div class="content py-4">
              <h1 class="articleTitle text-osc">{{ page.heading }}</h1>
              <div v-if="!loading && data" class="articleBodyFullWidth">
                <div class="articleContent">
                  <div
                    v-if="data.body"
                    v-lazy-container="{ selector: 'img' }"
                    class="mb-3"
                    v-html="filterHTML(data.body)"
                  />
                </div>
                <Tabs
                  v-if="data.tab_menus && data.tab_menus.length > 0"
                  :type="params.type"
                  :segment="params.segment"
                  :osc_year="params.osc_year"
                  :tab_menus="data.tab_menus"
                />
                <ArticleList
                  v-else
                  ref="article_list"
                  :type="params.type"
                  :endpoint="params.type+'/list'"
                />
              </div>
            </div>
          </div>
          <SideMenu v-if="page.sidemenu" class="col-lg-3 py-4 order-lg-1 fixed_menu" :data="page.sidemenu" />
        </div>
      </section>
      <section id="donate_btn_section" class="container bg-white py-4 clearfix d-none d-md-block">
        <DonateBtn v-view.once class="animated fadeInRight" />
      </section>
    </template>
  </div>
</template>
<script>
import Banner from "@/components/Banner.vue";
import DonateBtn from "@/components/DonateBtn.vue";
import SideMenu from "@/components/SideMenu.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Tabs from "@/components/Tabs.vue";
import ArticleList from "@/components/ArticleList.vue";
import _ from "lodash";

export default {
  name: "List",
  components: { Banner, DonateBtn, SideMenu, Breadcrumb, Tabs, ArticleList },
  data() {
    var to = this.$router.history.current;
    var current_osc_year = parseInt(localStorage.getItem("osc_year"));
    return {
      // default
      params: this.getParams(to),
      path: to.path,
      loading: true,
      page: null,
      data: null,
      list: null,
      // collapsed: true,
      current_osc_year: current_osc_year
    };
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
      // this.collapsed = true;
      if (this.page.sidemenu) {
        this.page.sidemenu.collapsed = true;
      }
      if (
        from.params.type != to.params.type ||
        from.params.osc_year != to.params.osc_year
      ) {
        this.params = this.getParams(to);
        this.init();
      } else {
        this.params = this.getParams(to);
        // this.scrollTo("#content_section");
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    toggleSideMenu() {
      // this.collapsed = !this.collapsed;
      if (this.page.sidemenu) {
        this.page.sidemenu.collapsed = !this.page.sidemenu.collapsed;
      }
    },
    getParams(to) {
      return {
        type: to.params.type,
        segment: to.params.segment,
        osc_year: to.params.osc_year
      };
    },
    init() {
      this.loading = true;

      let defaultTitle = this.$t("page." + this.params.type);
      this.page = {
        // Default Settings for page
        sidemenu: null,
        banner: null,
        title: defaultTitle,
        heading: defaultTitle
      };

      let past_bene = false;
      let current_bene = false;
      switch (this.params.type) {
        case "beneficiaries":
          past_bene = true;
          break;
      }
      this.$http
        .get(
          this.params.type == "page"
            ? `${this.params.type}/${this.params.segment}`
            : this.params.osc_year
            ? `${this.params.type}?osc_year=${this.params.osc_year}`
            : `${this.params.type}`
        )
        .then(response => {
          if (response.data.success) {
            var json = response.data;
            this.data = json.success && json.data ? json.data : null;

            this.page.banner = this.data.image;
            this.page.title =
              this.getDataValue("name", this.data) || this.page.title;
            this.page.heading =
              this.getDataValue("headline", this.data) || this.page.heading;
            this.$route.meta.title = this.page.title;

            this.$route.meta.desc = this.data.desc;
            this.$meta().refresh(); // Important!

            if (this.data && (this.data.left_menus || this.data.tab_menus)) {
              if (this.data.tab_menus && this.data.tab_menus.length > 0) {
                if (this.params.type == "beneficiaries") {
                  if (_.isEmpty(this.data.category)) {
                    this.$router.replace("/404");
                    return;
                  }
                  // // Get intersect tab menu
                  // let tab_menus = [];
                  // this.data.category.map(category => {
                  //   let tab_menu = _.find(this.data.tab_menus, {
                  //     url: `beneficiaries/${category.name}`
                  //   });
                  //   if (tab_menu) {
                  //     if (this.params.osc_year != null) {
                  //       tab_menu.url += `/${this.params.osc_year}`;
                  //     }
                  //     tab_menus.push(tab_menu);
                  //   } else {
                  //     console.log(category);
                  //   }
                  // });
                  if (this.params.osc_year != null) {
                    this.page.heading = `OSC ${this.params.osc_year} ${this.page.heading}`;
                    this.data.tab_menus.map(tab_menu => {
                      tab_menu.url += `/${this.params.osc_year}`;
                    });
                  } else {
                    this.page.heading = `OSC ${this.current_osc_year} ${this.page.heading}`;
                  }
                  // this.data.tab_menus = tab_menus;
                }

                if (this.data.left_menus && this.data.left_menus.length > 0) {
                  let item = {
                    url: this.params.type,
                    name: "SCMP",
                    type: "list",
                    sub_menus: this.data.tab_menus
                  };
                  this.data.left_menus.unshift(item);
                } else {
                  if (this.params.type == "beneficiaries") {
                    this.data.left_menu_header = this.$t("component.category");
                  }
                  this.data.left_menus = this.data.tab_menus;
                }
              }

              this.page.sidemenu = {
                parent: this.params.type,
                title: this.data.left_menu_header,
                items: this.data.left_menus,
                past_bene: past_bene,
                current_bene: current_bene,
                collapsed: true
              };
            } else {
              if (past_bene || current_bene) {
                this.page.sidemenu = {
                  past_bene: past_bene,
                  current_bene: current_bene,
                  collapsed: true
                };
              }
            }
          } else throw { response: response };
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped lang="scss" src="../assets/scss/list.scss"></style>